import { 
	ifAuthenticated, 
	ifAuthenticatedOnline, 
	ifDashboard,
	canAccess,
	AppTabs,
	store,
	trans,
} from '@/router/index'


import Vue from 'vue'
import Dashboard from '@/components/modules/dashboard/Dashboard'
import DashboardOptions from '@/components/modules/dashboard/settings/DashboardOptions'
import MyTaskboard from '@/components/modules/dashboard/MyTaskboard.vue'

export const dashboard = [
	{ 
		path: '/dashboard',
		beforeEnter: ifDashboard,
		component: AppTabs,
		props: {
			tabs: [
				{
					to: '/dashboard/',
					text: 'Dashboard',
				},				
				{
					to: '/dashboard/taskboard/',
					text: 'Taskboard',
					module: 'tasks'
				},
			],
		},
		children: [
			{
				path: '/dashboard/',
				beforeEnter: ifAuthenticated,
				component: Dashboard,
				meta: {
					title: trans('dashboard') 
				},
				props: {
					modelDef: 'dashboard',
					actionIcon: 'dashboard',
					title: 'Dashboard'
				}
			},				
			{
				path: '/dashboard/taskboard/',
				beforeEnter: (to, from, next) => { ifAuthenticated(to, from, next), canAccess('module', 'tasks', next) },
				component: MyTaskboard,
				meta: {
					title: trans('taskboard')
				},
				props: {
					modelDef: 'taskboard',
					actionIcon: 'dns',
					title: 'Taskboard'
				}
			},			
		],
	},
	{
		path: '/settingsdashboard/',
		name: 'settingsdashboard',
		beforeEnter: ifAuthenticatedOnline,
		component: AppTabs,
		props: {
			tabs: [
				{
					to: '/settingsdashboard/',
					text: 'Dashboard',
				},
			],
		},
		children: [	
			{
				path: '/settingsdashboard/',
				beforeEnter: ifAuthenticatedOnline,
				component: DashboardOptions,
			},
		],
	},
]